import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const NotImportantIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-notImportant"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M48 0 46 0C44.3427153 0 43 1.34271525 43 3L43 31C43 32.6572847 44.3427153 34 46 34L48 34C49.6572847 34 51 32.6572847 51 31L51 3C51 1.34271525 49.6572847 0 48 0ZM46 2 48 2C48.5527153 2 49 2.44728475 49 3L49 31C49 31.5527153 48.5527153 32 48 32L46 32C45.4472847 32 45 31.5527153 45 31L45 3C45 2.44728475 45.4472847 2 46 2ZM35 10 33 10C31.3427153 10 30 11.3427153 30 13L30 31C30 32.6572847 31.3427153 34 33 34L35 34C36.6572847 34 38 32.6572847 38 31L38 13C38 11.3427153 36.6572847 10 35 10ZM33 12 35 12C35.5527153 12 36 12.4472847 36 13L36 31C36 31.5527153 35.5527153 32 35 32L33 32C32.4472847 32 32 31.5527153 32 31L32 13C32 12.4472847 32.4472847 12 33 12ZM22 20 20 20C18.3427153 20 17 21.3427153 17 23L17 31C17 32.6572847 18.3427153 34 20 34L22 34C23.6572847 34 25 32.6572847 25 31L25 23C25 21.3427153 23.6572847 20 22 20ZM20 22 22 22C22.5527153 22 23 22.4472847 23 23L23 31C23 31.5527153 22.5527153 32 22 32L20 32C19.4472847 32 19 31.5527153 19 31L19 23C19 22.4472847 19.4472847 22 20 22Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
